import React, { useEffect, useState } from 'react';
import { ProviderService } from '../../../../api/Providers/Services';
import { trimServices } from '../serviceSelectors';

const defaultContext = {
  topServicesData: [],
  popularServiceRankingMap: {},
  highlightedService: null,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setHighlightedService: (service: ProviderService) => {},
};

const MAX_POPULAR_SERVICES = 4;

type PopularServiceRankingMap = {
  [key: number]: number;
};

export const HighlightedServicesStackContext = React.createContext(defaultContext);
const { Provider } = HighlightedServicesStackContext;

type HighlightedServicesStackProviderProps = {
  children: React.ReactElement;
  popularServices: ProviderService[];
};

export const HighlightedServicesStackProvider = (
  { children, popularServices }: HighlightedServicesStackProviderProps,
) => {
  const [topServicesData, setTopServicesData] = useState([]);
  const [highlightedService, setHighlightedService] = useState<ProviderService | null>(null);
  const [
    popularServiceRankingMap,
    setPopularServiceRankingMap,
  ] = useState<PopularServiceRankingMap>({});

  useEffect(() => {
    const popularServiceMap = trimServices(popularServices, MAX_POPULAR_SERVICES)
      .reduce((servicesMap, service, index) => ({ ...servicesMap, [service.id]: index + 1 }), {});

    setPopularServiceRankingMap(popularServiceMap);
    setTopServicesData(trimServices(popularServices, MAX_POPULAR_SERVICES));
  }, [popularServices]);

  return (
    <Provider value={{
      topServicesData, popularServiceRankingMap, highlightedService, setHighlightedService,
    }}
    >
      {children}
    </Provider>
  );
};
